// extracted by mini-css-extract-plugin
module.exports = {"nextButton":"NextButton_nextButton__SBAqe","rotateAnimation":"NextButton_rotateAnimation__JrB2J","flaticon-next":"NextButton_flaticon-next__1WPQ0"};